import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { ReceiptText } from "lucide-react";

import { PlaceholderPage } from "@/components/cinch/PlaceholderPage";
import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

function BillingMetricsPage() {
  return (
    <PlaceholderPage
      title="Billing Metrics"
      description="Billing health and performance metrics for the finance team."
      icon={ReceiptText}
    />
  );
}

export const billingMetricsModule: FeatureModule = {
  key: "billing_metrics",
  nav: {
    label: "Billing Metrics",
    icon: ReceiptText,
    to: "/billing-metrics",
    requires: "billing_metrics.read",
    order: 50,
    group: "Finance",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/billing-metrics",
      component: guarded("billing_metrics.read", BillingMetricsPage),
    }),
  ] as unknown as AnyRoute[],
};
